import React from 'react';
import { Check } from 'lucide-react';
import { formatByHint } from './criteriaBarUtils';

export default function CriteriaCheckmarkRow({
  label,
  actualValue,
  thresholdValue,
  formatHint,
  currency = 'USD',
  passes = true,
  className = '',
}) {
  const actual = formatByHint(actualValue, formatHint, currency);
  const threshold = formatByHint(thresholdValue, formatHint, currency);

  return (
    <div className={`inline-flex items-center gap-2 rounded-full border px-3 py-1 text-xs font-semibold ${
      passes ? 'bg-emerald-500/15 text-emerald-200 border-emerald-400/20' : 'bg-rose-500/15 text-rose-200 border-rose-400/20'
    } ${className}`}>
      <span title={label || ''}>
        {label || 'Criterio'}: {actual} <span className="opacity-70">vs</span> {threshold}
      </span>
      {passes ? <Check className="w-4 h-4" aria-hidden="true" /> : null}
    </div>
  );
}

